"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayFact = exports.RuleRequestType = exports.FactType = exports.Entity = exports.RuleCategory = exports.ArrayType = exports.RuleCompareOperator = exports.EntityDataType = exports.AttributeDatatype = void 0;
var AttributeDatatype;
(function (AttributeDatatype) {
    AttributeDatatype["String"] = "string";
    AttributeDatatype["Number"] = "number";
    AttributeDatatype["Boolean"] = "boolean";
    AttributeDatatype["Datetime"] = "datetime";
    AttributeDatatype["Array"] = "array";
    AttributeDatatype["StringArray"] = "string-array";
    AttributeDatatype["NumberArray"] = "number-array";
    AttributeDatatype["BooleanArray"] = "boolean-array";
    AttributeDatatype["DatetimeArray"] = "datetime-array";
})(AttributeDatatype || (exports.AttributeDatatype = AttributeDatatype = {}));
var EntityDataType;
(function (EntityDataType) {
    EntityDataType["Driver"] = "driver";
})(EntityDataType || (exports.EntityDataType = EntityDataType = {}));
var RuleCompareOperator;
(function (RuleCompareOperator) {
    RuleCompareOperator["EQUALS"] = "EQUALS";
    RuleCompareOperator["ARRAY_ELEMENT_EQUALS"] = "ARRAY_ELEMENT_EQUALS";
    RuleCompareOperator["NOT_EQUALS"] = "NOT_EQUALS";
    RuleCompareOperator["ARRAY_ELEMENT_NOT_EQUALS"] = "ARRAY_ELEMENT_NOT_EQUALS";
    RuleCompareOperator["INCLUDE"] = "INCLUDE";
    RuleCompareOperator["ARRAY_ELEMENT_INCLUDE"] = "ARRAY_ELEMENT_INCLUDE";
    RuleCompareOperator["ARRAY_ELEMENT_INCLUDE_ONE_OF_THE_ITEMS_FROM_SUBSTRING_ARRAY"] = "ARRAY_ELEMENT_INCLUDE_ONE_OF_THE_ITEMS_FROM_SUBSTRING_ARRAY";
    RuleCompareOperator["ARRAY_ELEMENT_EXCLUDE_ALL_ITEMS_FROM_SUBSTRING_ARRAY"] = "ARRAY_ELEMENT_EXCLUDE_ALL_ITEMS_FROM_SUBSTRING_ARRAY";
    RuleCompareOperator["EXCLUDE"] = "EXCLUDE";
    RuleCompareOperator["ARRAY_ELEMENT_EXCLUDE"] = "ARRAY_ELEMENT_EXCLUDE";
    RuleCompareOperator["LESS_THAN"] = "LESS_THAN";
    RuleCompareOperator["ARRAY_ELEMENT_LESS_THAN"] = "ARRAY_ELEMENT_LESS_THAN";
    RuleCompareOperator["LESS_THAN_OR_EQUALS"] = "LESS_THAN_OR_EQUALS";
    RuleCompareOperator["ARRAY_ELEMENT_LESS_THAN_OR_EQUALS"] = "ARRAY_ELEMENT_LESS_THAN_OR_EQUALS";
    RuleCompareOperator["GREATER_THAN"] = "GREATER_THAN";
    RuleCompareOperator["ARRAY_ELEMENT_GREATER_THAN"] = "ARRAY_ELEMENT_GREATER_THAN";
    RuleCompareOperator["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
    RuleCompareOperator["ARRAY_ELEMENT_GREATER_THAN_OR_EQUALS"] = "ARRAY_ELEMENT_GREATER_THAN_OR_EQUALS";
    RuleCompareOperator["IN"] = "IN";
    RuleCompareOperator["ARRAY_ELEMENT_IN"] = "ARRAY_ELEMENT_IN";
    RuleCompareOperator["NOT_IN"] = "NOT_IN";
    RuleCompareOperator["ARRAY_ELEMENT_NOT_IN"] = "ARRAY_ELEMENT_NOT_IN";
    RuleCompareOperator["IN_RANGE"] = "IN_RANGE";
    RuleCompareOperator["ARRAY_ELEMENT_IN_RANGE"] = "ARRAY_ELEMENT_IN_RANGE";
    RuleCompareOperator["ARRAY_INTERSECTION_HAS_ONE"] = "ARRAY_INTERSECTION_HAS_ONE";
    RuleCompareOperator["ARRAY_ELEMENT_ARRAY_INTERSECTION_HAS_ONE"] = "ARRAY_ELEMENT_ARRAY_INTERSECTION_HAS_ONE";
    RuleCompareOperator["ARRAY_INTERSECTION_HAS_ALL"] = "ARRAY_INTERSECTION_HAS_ALL";
    RuleCompareOperator["ARRAY_ELEMENT_ARRAY_INTERSECTION_HAS_ALL"] = "ARRAY_ELEMENT_ARRAY_INTERSECTION_HAS_ALL";
    RuleCompareOperator["EMPTY"] = "EMPTY";
    RuleCompareOperator["ARRAY_ELEMENT_EMPTY"] = "ARRAY_ELEMENT_EMPTY";
    RuleCompareOperator["NOT_EMPTY"] = "NOT_EMPTY";
    RuleCompareOperator["ARRAY_ELEMENT_NOT_EMPTY"] = "ARRAY_ELEMENT_NOT_EMPTY";
    RuleCompareOperator["STARTS_WITH"] = "STARTS_WITH";
    RuleCompareOperator["ARRAY_ELEMENT_STARTS_WITH"] = "ARRAY_ELEMENT_STARTS_WITH";
    RuleCompareOperator["NOT_STARTS_WITH"] = "NOT_STARTS_WITH";
    RuleCompareOperator["ARRAY_ELEMENT_NOT_STARTS_WITH"] = "ARRAY_ELEMENT_NOT_STARTS_WITH";
    RuleCompareOperator["ENDS_WITH"] = "ENDS_WITH";
    RuleCompareOperator["ARRAY_ELEMENT_ENDS_WITH"] = "ARRAY_ELEMENT_ENDS_WITH";
    RuleCompareOperator["NOT_ENDS_WITH"] = "NOT_ENDS_WITH";
    RuleCompareOperator["ARRAY_ELEMENT_NOT_ENDS_WITH"] = "ARRAY_ELEMENT_NOT_ENDS_WITH";
})(RuleCompareOperator || (exports.RuleCompareOperator = RuleCompareOperator = {}));
var ArrayType;
(function (ArrayType) {
    ArrayType["ANY"] = "any";
    ArrayType["ALL"] = "all";
})(ArrayType || (exports.ArrayType = ArrayType = {}));
var RuleCategory;
(function (RuleCategory) {
    RuleCategory[RuleCategory["FleetRouterDeliveryTerm"] = 0] = "FleetRouterDeliveryTerm";
    RuleCategory[RuleCategory["Alert"] = 1] = "Alert";
    RuleCategory[RuleCategory["Rate"] = 2] = "Rate";
    RuleCategory[RuleCategory["Workflow"] = 3] = "Workflow";
    RuleCategory[RuleCategory["FleetRouterRulePolicy"] = 4] = "FleetRouterRulePolicy";
})(RuleCategory || (exports.RuleCategory = RuleCategory = {}));
var Entity;
(function (Entity) {
    Entity["Fleet"] = "fleet";
    Entity["DeliveryProvider"] = "delivery_provider";
    Entity["Action"] = "action";
    Entity["FleetRouterRulePolicy"] = "fleet_router_rules";
})(Entity || (exports.Entity = Entity = {}));
var FactType;
(function (FactType) {
    FactType["Task"] = "task";
    FactType["Waypoint"] = "waypoint";
    FactType["Inventory"] = "inventory";
    FactType["Run"] = "run";
    FactType["Rate"] = "rate";
    FactType["User"] = "user";
    FactType["DeliveryBlock"] = "delivery_block";
    FactType["PlannedDeliveryWindow"] = "planned_delivery_window";
    FactType["DeliveryWindow"] = "delivery_window";
})(FactType || (exports.FactType = FactType = {}));
var RuleRequestType;
(function (RuleRequestType) {
    RuleRequestType["Evaluate"] = "rule:evaluate";
})(RuleRequestType || (exports.RuleRequestType = RuleRequestType = {}));
var DisplayFact;
(function (DisplayFact) {
    DisplayFact["Task"] = "task";
    DisplayFact["QueryTask"] = "query_task";
    DisplayFact["User"] = "user";
    DisplayFact["DeliveryBlock"] = "delivery_block";
    DisplayFact["PlannedDeliveryWindow"] = "planned_delivery_window";
    DisplayFact["DeliveryWindow"] = "delivery_window";
})(DisplayFact || (exports.DisplayFact = DisplayFact = {}));
//# sourceMappingURL=rule_types.js.map